import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MasterDetailModule } from '@sdbn/common';
import { PagerComponent } from './component/pager.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { EquipmentLogModule } from "@sdbn/tmc-common";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ApplicationClientCommonModule,
    EquipmentLogModule,
    MasterDetailModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule
],
  declarations: [
    PagerComponent
  ]
})
export class PagerModule { }

